import NotInterestedIcon from "@mui/icons-material/NotInterested";
import {
    CardHeader,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import * as React from "react";
import { CoatOfArms } from "../../components/CoatOfArms";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { GameGeneralEventCreate } from "./gameGeneralEventCreate";
import cookie from "react-cookies";

interface GameGeneralEventStates {
    sendingReward: string, // string <> reward id
    events: any[];
    loading: boolean;
    form: {
        keyword: undefined | string;
        sort: string;
    }
    totalRecords: number;
    pushModalVisible: boolean;
    selectedPlayer: any | null;
    deviceModalVisible: boolean;
    anchorEl: any;
    rowsPerPage: number;
    page: number;
    menuVisible: boolean;
}

export interface SearchFormProps {
    onFormSubmit(): void;
}

interface GameGeneralEventProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
}

export class GameGeneralEvent extends React.Component<GameGeneralEventProps, GameGeneralEventStates> {
    username: string;

    constructor(props: GameGeneralEventProps) {
        super(props);

        this.state = {
            form: {
                keyword: undefined,
                sort: "joined_DESC",
            },
            sendingReward: '',
            events: [],
            loading: true,
            totalRecords: 0,
            pushModalVisible: false,
            selectedPlayer: null,
            deviceModalVisible: false,
            anchorEl: null,
            menuVisible: false,
            // Pagination
            page: 0,
            rowsPerPage: 10,
        };
        this.username = cookie.load("username");
        
        document.title = Helpers.documentTitle("Events");
    }

    componentDidMount() {
        this.fetchGameGeneralEvents();
    }

    fetchGameGeneralEvents = () => {
        axios.get(`${Config.getInstance.apiUrl}/api/game_general_event`, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            },
        }).then(response => {
            const data = response.data;
            const { sendingReward, events } = data;
            this.setState({
                loading: false,
                sendingReward,
                events: events || [],
            });
        }).catch(_ => {
            PopupMessage.error("Something went wrong!");
        });
    }

    refreshData = () => {
        this.fetchGameGeneralEvents();
    }

    startStopEvent = (id: string, name: string, active: boolean)  => {
        if (confirm(`Are you sure you want to ${!active ? 'start' : 'stop'} this event? (${id}-${name}) `)) {   
            axios.post(`${Config.getInstance.apiUrl}/api/game_general_event/set-status`, {
                id,
                active: !active,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            }).then(result => {
                this.refreshData();
            }).catch(() => {
                PopupMessage.error(`Couldn't diable event '${name}'`);
            });
            
        }
    };

    sendReward = (id: string, name: string, active: boolean)  => {
        if (active) {
            alert('The event is ongoing!');
            return;
        }

        if (confirm(`Are you sure you want to send rewards of event? (${id}-${name}) `)) {   
            axios.post(`${Config.getInstance.apiUrl}/api/game_general_event/send-rewards`, {
                id,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            }).then(result => {
                this.refreshData();
            }).catch(() => {
                PopupMessage.error(`Couldn't send rewards of event '${name}'`);
            });
            
        }
    };
    
    openRowMenu = (event: any) => this.setState({anchorEl: event.currentTarget}, () => this.setState({menuVisible: true}));
    /**
     * For menu closing we have two functions to make animations smoother
     */
    closeRowMenu = () => this.setState({menuVisible: false});
    clearMenuAnchor = () => this.setState({anchorEl: null});
    

    renderAllianceInfo(item: any) {
        if (!item.squad) {
            return null;
        }

        return <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CoatOfArms emblem={item.squad.flag} size="small"/>
            <span style={{ marginLeft: 5 }}>{item.squad.name}</span>
        </div>
    }

    formatTableBody = (items: any[]) => {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        return items.map(item => (
            <TableRow
                key={item.id}
                hover={true}
            >
                <TableCell align="center"  style={{ width: 80 }}>
                    {item.id}
                </TableCell>
                <TableCell align="center"  style={{width: 80}}>
                    {item.name}
                </TableCell>
                <TableCell align="center" style={{width: 150}}>
                    {item.start_date}
                </TableCell>
                <TableCell align="center" style={{width: 130, color: 'red'}}>
                    {item.end_date}
                </TableCell>
                <TableCell align="center" style={{width: 70}}>
                    {item.active ? 'true' : 'false'}
                </TableCell>
                <TableCell align="center" style={{width: 60}}>
                    {item.sent_rewards  ? 'true' : 'false'}
                </TableCell>
                <TableCell>
                    {this.username !== item.username?  <Button disableElevation variant="contained" style={{ width: 150 }} color="primary" onClick={() => 
                        this.sendReward(item.id, item.name, item.active)} disabled={this.state.sendingReward.length !== 0}> 
                        {this.state.sendingReward === item.id ? 'Sending Reward...' : 'Send Rewards'}
                    </Button> : null}
                </TableCell>
                <TableCell>
                    <GameGeneralEventCreate type="edit" roles={`roles`} defaultValues={item} refreshData={this.refreshData} {...this.props}/>
                </TableCell>
                <TableCell>
                    <Button disableElevation variant="contained" color="secondary"  /*disabled={item.active === true} */
                        onClick={() => this.startStopEvent(item.id, item.name, item.active)} disabled={item.sent_rewards}>
                        {item.active === false ? 'Start': 'Stop'}
                    </Button>
                </TableCell>
            </TableRow>
        ));
    };

    pageContent = (items) => {
        if (!this.state.loading && items.length === 0) {
            return <div className="no-items-placeholder">
                <NotInterestedIcon/>
                <h3>No events found</h3>
            </div>;
        }

        return <React.Fragment>
            <CardHeader
                title="Game general event"
                action={
                    <GameGeneralEventCreate type="new" roles={'roles'} defaultValues={{}} refreshData={this.refreshData} {...this.props}/>
                }
            />
            
            <Table className="min-table-size">
                <TableHead>
                    <TableRow>
                        <TableCell style={{width: 300}} align="center">Event Id</TableCell>
                        <TableCell style={{width: 220}} align="center">Event Name</TableCell>
                        <TableCell style={{width: 210}} align="center">Start Date</TableCell>
                        <TableCell style={{width: 210}} align="center">End Date</TableCell>
                        <TableCell style={{width: 120}} align="center">Enable</TableCell>
                        <TableCell style={{width: 80}} align="center">Sent Rewards</TableCell>
                        <TableCell style={{width: 40}}></TableCell>
                        <TableCell style={{width: 40}}></TableCell>
                        
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.formatTableBody(items)}
                </TableBody>
            </Table>
        </React.Fragment>;
    }

    searchInput(e: any, key: string) {
        const tempForm = {...this.state.form};
        tempForm[key] = e.target.value;

        this.setState({form: tempForm});
    }

    render() {
        /*
        return (
            <div className="no-items-placeholder" style={{ color: 'red' }} >
            <NotInterestedIcon/>
                <h1>You not have access to this page!</h1>
            </div>
        )*/
        return <React.Fragment>
            <div style={{ marginBottom: 20 }}>
                <Paper className="root" elevation={0}>
                    {
                        this.pageContent(this.state.events)
                    }
                </Paper>
            </div>
            </React.Fragment>
        
    }
}
